MW.modules.promiseStore = (function(){
  var manifestKey = "lookupTable";
  var storage = MW.modules.storage;
  if(!storage.enabled) {
    return {
      get: function() {
        return new Promise(function(resolve, reject) {
          reject();
        });
      },
      set: function(key, value) {
        return new Promise(function(resolve, reject) {
          resolve(value);
        });
      },
      getOrSet: function(key, fn) {
        return fn();
      },
      getManifest: function() {
        return {};
      }
    };
  }
  function getManifest() {
    return storage.get(manifestKey) || {};
  }
  function setManifest(obj) {
    storage.set(manifestKey, obj);
  }
  function noteAccess(key) {
    var manifest = getManifest();
    manifest[key] = Date.now();
    setManifest(manifest);
  }
  function removeExpired(manifest) {
    Object.keys(manifest).forEach(function(key){
      if(storage.get(key).expiresAt < Date.now()) {
        storage.remove(key);
        delete manifest[key];
      }
    });
    setManifest(manifest);
  }
  function removeOldest(manifest) {
    var oldest = Object.keys(manifest).reduce(function(lastKey, key){
      var lastTime = manifest[lastKey] || Date.now();
      if(lastTime < manifest[key]) {
        return lastKey;
      } else {
        return key;
      }
    });
    storage.remove(oldest);
    delete manifest[oldest];
    setManifest(manifest);
    return manifest;
  }
  function limitStoreLength(length) {
    var manifest = getManifest();
    length = length || 15;
    removeExpired(manifest);
    while(Object.keys(manifest).length > length) {
      manifest = removeOldest(manifest);
    }
  }
  return {
    get: function(key) {
      return new Promise(function(resolve, reject){
        var value = storage.get(key);
        if(value !== null && value.expiresAt > Date.now()) {
          noteAccess(key);
          resolve(value);
        } else {
          storage.remove(key);
          reject(value);
        }
      });
    },
    set: function(key, value) {
      return new Promise(function(resolve){
        value.expiresAt = value.expiresAt || Date.now()+1000*60*30; //cache for 30 min in localStorage
        storage.set(key, value);
        noteAccess(key);
        resolve(value);
        setTimeout(limitStoreLength, 50);
      });
    },
    getOrSet: function(key, fn) {
      return MW.modules.promiseStore.get(key).catch(function(){
        return fn().then(function(value){
          return MW.modules.promiseStore.set(key, value);
        });
      });
    },
    getManifest: getManifest
  };
}());